import axios from "axios";
import { config } from "../config";

export const registerBusinessPhoto = async (
  businessId: string,
  url: string,
  token?: string
) => {
  return axios.post(
    `${config.api.baseUrl}/business/${businessId}/photos`,
    { url },
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
  );
};
